<template>
  <el-dialog
    :title="dialogTitle"
    center
    :visible.sync="dialog"
    :before-close="close"
    width="70%"
    class="me-modal-wrapper"
    custom-class="me-modal"
  >
    <div class="me-modal-actions" v-if="recordLoaded">
      <i v-if="canRemove" class="el-icon-delete me-modal-action me-modal-action--danger"
        title="Excluir/cancelar pré-postagem" @click="removeTag"></i>
      <i v-if="canDc" class="el-icon-tickets me-modal-action me-modal-action--info"
        title="Editar Declaração de Conteúdo" @click="$refs.dcEdit.open(recordId)"></i>
      <i v-if="canEdit && !isEditing" class="el-icon-edit me-modal-action me-modal-action--warning"
        title="Editar esse objeto" @click="editing = true"></i>
      <i class="el-icon-document me-modal-action"
        title="Comprovante de postagem" @click="proofTag"></i>
      <i class="el-icon-printer me-modal-action me-modal-action--primary"
        title="Imprimir etiqueta" @click="printTag"></i>
    </div>
    <PrepostDCEdit ref="dcEdit" />
    <el-tabs v-model="activeTab">
      <el-tab-pane label="Etiqueta" name="edit">
        <!-- Só leitura = texto; editável = input (PrePostField decide pelo `editable`) -->
        <el-form size="mini" label-position="top" class="me-form" @submit.native.prevent>
          <div class="me-object">
            <div class="me-object__main">
              <span class="me-object__tag">{{ record.tag || tag }}</span>
              <el-tag v-if="statusCode" size="mini" :type="statusTagType(statusCode)" disable-transitions>
                {{ statusLabel(statusCode) }}
              </el-tag>
              <el-tag v-if="record.plp" size="mini" type="info" disable-transitions>PLP gerada</el-tag>
            </div>
            <div class="me-object__extras">
              <template v-if="extras.length > 0">
                <el-tag v-for="extra in extras" :key="extra" size="mini" type="info" disable-transitions>{{ extra }}</el-tag>
              </template>
              <span v-else class="me-muted">Sem serviços adicionais</span>
            </div>
          </div>
          <p v-if="lockHint" class="me-lock-hint"><i class="el-icon-lock"></i> {{ lockHint }}</p>
          <p v-else-if="isEditing" class="me-lock-hint"><i class="el-icon-edit-outline"></i> Os campos com caixa podem ser alterados; os demais são somente leitura.</p>

          <div class="me-section">Remetente</div>
          <el-row :gutter="12">
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField label="CEP" :value="formatZipcode(record.sourcezipcode)" />
            </el-col>
            <el-col :xs="24" :sm="16" :md="10">
              <PrePostField :label="$t('endereco')" :value="record.sourceaddress" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('numero')" :value="record.sourcenumber" :editable="editableLabel">
                <el-input v-model="record.sourcenumber" v-mask="'######'" maxlength="6"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="12" :sm="16" :md="6">
              <PrePostField :label="$t('complemento')" :value="record.sourcecomplement" :editable="editableLabel">
                <el-input v-model="record.sourcecomplement" maxlength="40"></el-input>
              </PrePostField>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :xs="12" :sm="8" :md="7">
              <PrePostField :label="$t('bairro')" :value="record.sourceneighborhood" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="7">
              <PrePostField :label="$t('cidade')" :value="record.sourcecity" />
            </el-col>
            <el-col :xs="8" :sm="8" :md="3">
              <PrePostField :label="$t('estado')" :value="record.sourcestate" />
            </el-col>
            <el-col :xs="16" :sm="24" :md="7">
              <PrePostField :label="$t('contato')" :value="record.contact" />
            </el-col>
          </el-row>

          <div class="me-section">Destinatário</div>
          <el-row :gutter="12">
            <el-col :xs="24" :sm="12">
              <PrePostField :label="$t('nome')" :value="record.destinyname" :editable="editableLabel">
                <el-input v-model="record.destinyname" maxlength="60"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="24" :sm="12">
              <PrePostField :label="$t('aos-cuidados')" :value="record.care" :editable="editableLabel">
                <el-input v-model="record.care" maxlength="57"></el-input>
              </PrePostField>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :xs="24" :sm="12" :md="6">
              <PrePostField :label="$t('cpf/cnpj')" :value="formatDocument(record.destinyFederalid)" :editable="editableLabel">
                <el-input v-model="record.destinyFederalid" v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <PrePostField :label="$t('inscricao-estadual')" :value="record.destinyStateRegistration" :editable="editableLabel">
                <el-input v-model="record.destinyStateRegistration" maxlength="20"></el-input>
              </PrePostField>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField label="CEP" :value="formatZipcode(record.destinyzipcode)" />
            </el-col>
            <el-col :xs="24" :sm="16" :md="10">
              <PrePostField :label="$t('endereco')" :value="record.destinyaddress" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('numero')" :value="record.destinynumber" :editable="editableLabel">
                <el-input v-model="record.destinynumber" v-mask="'######'" maxlength="6"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="12" :sm="16" :md="6">
              <PrePostField :label="$t('complemento')" :value="record.destinycomplement" :editable="editableLabel">
                <el-input v-model="record.destinycomplement" maxlength="40"></el-input>
              </PrePostField>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :xs="12" :sm="8" :md="7">
              <PrePostField :label="$t('bairro')" :value="record.destinyneighborhood" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="7">
              <PrePostField :label="$t('cidade')" :value="record.destinycity" />
            </el-col>
            <el-col :xs="8" :sm="8" :md="3">
              <PrePostField :label="$t('estado')" :value="record.destinystate" />
            </el-col>
            <el-col :xs="16" :sm="24" :md="7">
              <PrePostField :label="$t('telefone')" :value="record.phone" :editable="editableLabel">
                <el-input v-model="record.phone" v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
              </PrePostField>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :xs="24" :sm="12">
              <PrePostField label="E-mail" :value="record.mail" :editable="editableReferences">
                <el-input v-model="record.mail"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="24" :sm="12">
              <PrePostField :label="$t('pedido')" :value="record.request" :editable="editableReferences">
                <el-input v-model="record.request"></el-input>
              </PrePostField>
            </el-col>
          </el-row>

          <div class="me-section">Serviço e valores</div>
          <el-row :gutter="12">
            <el-col :xs="24" :sm="12" :md="8">
              <PrePostField :value="issuedServiceLabel">
                <template slot="label">
                  {{ $t("servico") }}
                  <!-- Troca pela malha (pedido econômico, emitido expresso): selo curto, detalhe no hover -->
                  <el-tooltip v-if="serviceSwappedByMalha" placement="top">
                    <div slot="content" class="me-service-upgrade__tip">
                      <b>{{ $t("servico-contratado-malha", { contracted: contractedServiceLabel, issued: issuedServiceLabel }) }}</b><br />
                      {{ $t("troca-pela-malha-detalhe") }}
                    </div>
                    <span class="me-service-upgrade"><i class="el-icon-top"></i> {{ $t("troca-pela-malha") }}</span>
                  </el-tooltip>
                </template>
              </PrePostField>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <PrePostField :label="$t('departamento')" :value="record.department ? record.department.name : ''" />
            </el-col>
            <el-col :xs="12" :sm="12" :md="4">
              <PrePostField :label="$t('tipo')" :value="typeLabel" />
            </el-col>
            <el-col :xs="12" :sm="12" :md="4">
              <PrePostField :label="$t('cartao-postagem')" :value="record.cardpost ? record.cardpost.code : ''" />
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('altura')" :value="record.height" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('largura')" :value="record.width" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('comprimento')" :value="record.length" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('peso')" :value="record.weight" />
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('valor-declarado')" :value="formatMoney(record.declaredValue)" :editable="editableLabel">
                <el-input v-model="record.declaredValue" type="number"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField label="Tabela" :value="formatMoney(record.pricetable)" />
            </el-col>
          </el-row>
          <el-row :gutter="12" v-if="user.type === '1'">
            <el-col :xs="12" :sm="8" :md="4">
              <PrePostField :label="$t('valor')" :value="formatMoney(record.value)" />
            </el-col>
          </el-row>

          <div class="me-section">Nota fiscal / DC-e</div>
          <p v-if="!editableNfe && !hasNfe" class="me-muted me-section__empty">Nenhuma nota fiscal ou DC-e informada.</p>
          <el-row v-else :gutter="12">
            <el-col :xs="24" :sm="12" :md="9">
              <PrePostField label="Chave NF-e / DC-e" :value="record.nfe.key" :editable="editableNfe">
                <el-input v-model="record.nfe.key"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="12" :sm="6" :md="5">
              <PrePostField label="Número" :value="record.nfe.number" :editable="editableNfe">
                <el-input v-model="record.nfe.number"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="12" :sm="6" :md="4">
              <PrePostField label="Série" :value="record.nfe.serie" :editable="editableNfe">
                <el-input v-model="record.nfe.serie"></el-input>
              </PrePostField>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6">
              <PrePostField :label="$t('valor')" :value="record.nfe.value" :editable="editableNfe">
                <el-input v-model="record.nfe.value"></el-input>
              </PrePostField>
            </el-col>
          </el-row>

          <template v-if="record.volumes.length > 0">
            <div class="me-section">Volumes</div>
            <el-table :data="record.volumes" size="mini" class="me-volumes" style="width: 100%">
              <el-table-column type="index" label="#" width="50"></el-table-column>
              <el-table-column prop="altura" :label="$t('altura')"></el-table-column>
              <el-table-column prop="largura" :label="$t('largura')"></el-table-column>
              <el-table-column prop="comprimento" :label="$t('comprimento')"></el-table-column>
              <el-table-column prop="peso" :label="$t('peso')"></el-table-column>
            </el-table>
          </template>

          <div class="me-section">Postagem</div>
          <el-row :gutter="12">
            <el-col :xs="12" :sm="6">
              <PrePostField label="O.S." :value="record.orderservices ? record.orderservices.id : ''" />
            </el-col>
            <el-col :xs="24" :sm="18">
              <PrePostField :label="$t('observacao')" :value="record.observation" />
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <!-- `lazy`: só monta (e só busca /api/history) quando a aba é aberta. -->
      <el-tab-pane label="Rastreio" name="tracking" lazy>
        <ObjectSroDetail :tag="tag || record.tag" />
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ isEditing && activeTab === "edit" ? "Cancelar" : "OK" }}</el-button>
      <el-button v-show="isEditing && activeTab === 'edit'" type="primary" @click="save()">Salvar</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { PrepostService } from "@/services/customers/prepost.services";
import { ServicesService } from "@/services/customers/services.services";
import { UserService } from "@/services/users/user.services";
import { OPEN_PRE_STATUS_OPTIONS, statusLabel, statusTagType } from "@/xpost/helpers/prepost-status";
import ObjectSroDetail from "@/xpost/views/services/objects.sro/ObjectSroDetail";
import PrepostDCEdit from "@/xpost/views/services/pre.post/components/PrePostDCEdit.vue";
import PrePostField from "@/xpost/views/services/pre.post/components/PrePostField.vue";

// Regras de edição, espelhando o PUT /api/prepost/:id do backend:
// - só Pré-postagem (1), Coletado (2) e Pendente (10) aceitam alteração; nos demais status a
//   etiqueta já virou postagem e o backend recusa;
// - com PLP gerada, pedido e e-mail ficam travados (regra que a tela já aplicava);
// - NF-e/DC-e não muda depois de ter chave (já registrada nos Correios);
// - endereços, serviço, departamento, dimensões, tipo e cartão são só leitura neste modal.
const EDITABLE_STATUSES = ["1", "2", "10"];
// Ações de pré-postagem (excluir, declaração de conteúdo): pré em aberto, mesma regra da
const PRE_STATUSES = OPEN_PRE_STATUS_OPTIONS.map(String);
const TYPE_LABELS = { "001": "Pacote / Caixa", "002": "Rolo / Cilindro / Esférico", "003": "Envelope" };

// Troca pela malha: cliente pediu um serviço da família econômica e a etiqueta saiu na família
// expressa (regra do DefineServiceMalha: malha e destino capital). serviceCode = pedido, services = emitido.
const MALHA_ECONOMIC_SERVICES = ["03298", "03336", "04227", "04391"];
const MALHA_EXPRESS_SERVICES = ["03220", "03280"];
const normalizeServiceCode = (code) => String(code || "").replace(/\D/g, "").padStart(5, "0");

export default {
  name: "prepost",
  props: {
    id: String,
    dialog: Boolean,
    state: String,
    tag: String,
    tab: String,
  },
  components: {
    ObjectSroDetail,
    PrepostDCEdit,
    PrePostField,
  },
  data() {
    return {
      // NF-e/DC-e já tem chave ao carregar: não pode ser alterada.
      nfeLocked: false,
      // Serviço que o cliente pediu, quando a malha trocou o emitido (nome buscado por código).
      contractedService: null,
      record: {
        digital: undefined,
        register: undefined,
        services: { id: "" },
        department: { id: "" },
        customers: { id: "" },
        orderservices: { id: "" },
        nfe: { key: "", value: "", serie: "", number: "" },
        volumes: [],
      },
      user: { type: "2", name: "" },
      activeTab: this.tab || "edit",
      editing: false,
      resolvedId: "",
      resolving: false,
      recordLoaded: false,
      fetching: false,
    };
  },
  computed: {
    recordId() {
      return this.id || this.resolvedId;
    },
    statusCode() {
      return this.record.status === undefined || this.record.status === null ? "" : String(this.record.status);
    },
    isPre() {
      return PRE_STATUSES.includes(this.statusCode);
    },
    // Status ainda aceita alteração no backend.
    canEdit() {
      return this.recordLoaded && EDITABLE_STATUSES.includes(this.statusCode);
    },
    // Modo edição: pedido pela listagem (state != VIEW) ou pelo lápis, e só se o status permitir.
    isEditing() {
      return this.canEdit && (this.editing || this.state !== "VIEW");
    },
    // Dados da etiqueta: número/complemento, destinatário, telefone, valor declarado.
    editableLabel() {
      return this.isEditing;
    },
    // Referências (pedido, e-mail): travadas depois da PLP.
    editableReferences() {
      return this.isEditing && !this.record.plp;
    },
    editableNfe() {
      return this.isEditing && !this.nfeLocked;
    },
    canRemove() {
      return this.isPre && !this.record.plp;
    },
    canDc() {
      return this.isPre && this.statusCode !== "10";
    },
    extras() {
      const list = [];
      if (this.record.register) list.push("A.R.");
      if (this.record.digital) list.push("AR-E");
      if (this.record.ownhand) list.push("M.P.");
      if (this.record.ap) list.push("A.P.");
      if (this.record.dceExempt) list.push("Isento DCE");
      return list;
    },
    typeLabel() {
      return TYPE_LABELS[this.record.type] || this.record.type || "";
    },
    hasNfe() {
      const nfe = this.record.nfe || {};
      return ["key", "number", "serie", "value"].some((field) => nfe[field] !== null && nfe[field] !== undefined && String(nfe[field]).trim() !== "");
    },
    lockHint() {
      if (!this.recordLoaded) return "";
      if (!this.canEdit) {
        return `Etiqueta com status "${statusLabel(this.statusCode)}": os dados não podem mais ser alterados.`;
      }
      if (this.isEditing && this.record.plp) {
        return "PLP já gerada: pedido e e-mail não podem ser alterados.";
      }
      return "";
    },
    serviceSwappedByMalha() {
      const record = this.record || {};
      const requested = normalizeServiceCode(record.serviceCode);
      const issued = normalizeServiceCode(record.services && record.services.code);
      return !!record.malha && MALHA_ECONOMIC_SERVICES.includes(requested) && MALHA_EXPRESS_SERVICES.includes(issued);
    },
    contractedServiceLabel() {
      const code = normalizeServiceCode(this.record.serviceCode);
      const name = this.contractedService && this.contractedService.name ? this.contractedService.name : "";
      return name ? `${name} (${code})` : code;
    },
    issuedServiceLabel() {
      const service = this.record.services || {};
      return service.name ? `${service.name} (${service.code || ""})` : service.code || "";
    },
    dialogTitle() {
      if (this.activeTab === "tracking") return "Rastreio do objeto";
      return this.isEditing ? "Editar etiqueta" : "Visualizar etiqueta";
    },
  },
  watch: {
    id() {
      if (this.id) this.fetchRecords();
    },
    dialog(open) {
      if (open) {
        this.activeTab = this.tab || "edit";
        this.editing = false;
        if (this.activeTab === "edit") this.ensureRecord();
      }
    },
    activeTab(tab) {
      if (tab === "edit") this.ensureRecord();
    },
  },
  methods: {
    statusLabel,
    statusTagType,
    formatZipcode(value) {
      const digits = String(value || "").replace(/\D/g, "");
      return digits.length === 8 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : String(value || "");
    },
    formatDocument(value) {
      const raw = String(value || "").replace(/[^0-9A-Za-z]/g, "");
      if (raw.length === 11) return raw.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
      if (raw.length === 14) return raw.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
      return String(value || "");
    },
    formatMoney(value) {
      if (value === null || value === undefined || value === "") return "";
      const number = Number(value);
      if (Number.isNaN(number)) return String(value);
      return `R$ ${number.toFixed(2).replace(".", ",")}`;
    },
    close() {
      this.$emit("close");
    },
    downloadFile(href, name) {
      const downloadLink = document.createElement("a");
      downloadLink.href = href;
      downloadLink.download = name;
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    printTag() {
      const vm = this;
      const tag = vm.record.tag || vm.tag;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.print([tag], { declared: true, warning: true, model: "1", type: "1" })
        .then((response) => vm.downloadFile(response, `${tag}.pdf`))
        .catch((error) => vm.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    proofTag() {
      const vm = this;
      const tag = vm.record.tag || vm.tag;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.proof(tag)
        .then((response) => vm.downloadFile(response, `${tag}-comprovante.pdf`))
        .catch((error) => vm.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    removeTag() {
      const vm = this;
      const tag = vm.record.tag || vm.tag;
      vm.$confirm(i18n.t("confirmar-eliminacao-prepostagem", { id: tag }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PrepostService.delete(vm.recordId)
          .then(() => {
            vm.$message({ type: "success", duration: 5000, message: "Pré-postagem removida com sucesso!" });
            // a listagem ouve este evento e tira a linha sem refazer a busca
            vm.$bus.$emit("prepost-removed", vm.recordId);
            vm.$emit("close");
          })
          .catch((error) => vm.$message({ type: "error", message: error, duration: 5000 }))
          .finally(() => loading.close());
      });
    },
    // Fecha só depois da resposta: antes fechava antes de salvar e escondia o erro.
    save() {
      const vm = this;
      if (!vm.recordId || !vm.isEditing) {
        vm.$emit("close");
        return;
      }
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.update(vm.recordId, vm.record)
        .then(() => {
          vm.$message({ type: "success", message: "Pré-postagem atualizada com sucesso!" });
          vm.$emit("saved", vm.recordId);
          vm.$emit("close");
        })
        .catch((error) => vm.$message({ type: "error", message: error, duration: 5000 }))
        .finally(() => loading.close());
    },
    mapVolumes(volumes) {
      const parsedVolumes = JSON.parse(volumes);
      return parsedVolumes.map((volume) => ({
        ...volume,
        peso: Number(volume.peso).toFixed(2),
      }));
    },
    ensureRecord() {
      const vm = this;
      if (vm.recordLoaded || vm.resolving || vm.fetching) return;
      if (vm.recordId) return vm.fetchRecords();
      if (!vm.tag) return;

      vm.resolving = true;
      PrepostService.tag(vm.tag)
        .then((record) => {
          vm.resolvedId = record && record.id ? record.id : "";
          if (vm.resolvedId) vm.fetchRecords();
        })
        .catch(() => {
          // Etiqueta sem prepostagem nossa: a aba fica vazia, o rastreio não.
        })
        .finally(() => {
          vm.resolving = false;
        });
    },
    fetchRecords() {
      const vm = this;
      if (!vm.recordId) return false;
      vm.fetching = true;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.get(vm.recordId)
        .then((response) => {
          if (!response.department) response.department = { id: "" };
          if (!response.orderservices) response.orderservices = { id: "" };

          const nfe = response.nfe ? JSON.parse(response.nfe) : { value: "", serie: "", number: "", key: "" };
          if (nfe.dceId) nfe.key = nfe.dceId;
          vm.nfeLocked = !!nfe.key;
          response.nfe = nfe;

          response.volumes = response.volumes ? vm.mapVolumes(response.volumes) : [];

          vm.record = response;
          vm.contractedService = null;
          if (vm.serviceSwappedByMalha) {
            ServicesService.code(normalizeServiceCode(response.serviceCode))
              .then((data) => (vm.contractedService = data))
              .catch(() => {});
          }
          vm.recordLoaded = true;
        })
        .catch((error) => vm.$message({ type: "error", message: error, duration: 5000 }))
        .finally(() => {
          vm.fetching = false;
          loading.close();
        });
    },
  },
  mounted() {
    const vm = this;
    if (vm.dialog && vm.activeTab === "edit") vm.ensureRecord();
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
      })
      .catch((error) => vm.$message({ type: "error", message: error }));
  },
};
</script>
<style>
/* Moldura do modal: altura limitada à janela, corpo rolável */
.me-modal-wrapper {
  display: flex;
}
.me-modal {
  margin: auto !important;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.me-modal .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.me-modal .el-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.me-modal .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* Ações no canto do modal */
.me-modal-actions {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 5;
}
.me-modal-action {
  font-size: 18px;
  color: #606266;
  cursor: pointer;
  margin-left: 12px;
  vertical-align: middle;
  transition: opacity 0.15s ease;
}
.me-modal-action:hover {
  opacity: 0.65;
}
.me-modal-action--primary {
  color: rgba(34, 65, 141, 0.55);
}
.me-modal-action--warning {
  color: #e6a23c;
}
.me-modal-action--danger {
  color: rgba(245, 108, 108, 0.85);
}
.me-modal-action--info {
  color: #909399;
}

/* Três níveis de hierarquia: seção (caixa alta + única régua) > rótulo (apagado) > valor */
.me-modal .me-form .el-form-item {
  margin-bottom: 10px;
}
.me-modal .me-form .el-form-item__label {
  font-size: 11px;
  line-height: 16px;
  padding: 0 0 2px;
  color: #a0a4ab;
}
.me-modal .me-section {
  margin: 22px 0 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e4e7ed;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #606266;
}
.me-modal .me-object + .me-section,
.me-modal .me-lock-hint + .me-section {
  margin-top: 12px;
}
.me-modal .me-section__empty {
  margin: 0 0 6px;
}

/* Cabeçalho do objeto: código em destaque, status e adicionais como tags neutras */
.me-modal .me-object {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin: 4px 0 6px;
}
.me-modal .me-object__main,
.me-modal .me-object__extras {
  display: flex;
  align-items: center;
  gap: 6px;
}
.me-modal .me-object__tag {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #303133;
  font-variant-numeric: tabular-nums;
}
.me-modal .me-muted {
  font-size: 12px;
  color: #a0a4ab;
}
.me-modal .me-lock-hint {
  margin: 0 0 8px;
  font-size: 12px;
  color: #909399;
}
.me-modal .me-volumes {
  margin-bottom: 12px;
}

/* Troca de serviço pela malha */
.me-service-upgrade__tip {
  max-width: 360px;
  line-height: 1.5;
}
.me-service-upgrade {
  margin-left: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #22418d;
  cursor: help;
  vertical-align: middle;
  white-space: nowrap;
}
</style>
